import { SceneSetters } from "../../types";

const sceneConfig: Phaser.Types.Scenes.SettingsConfig = {
  active: false,
  visible: false,
  key: "End",
};

type Sprite = Phaser.GameObjects.GameObject & { body: any };

export class EndScene extends Phaser.Scene {
  private cursorKeys?: Phaser.Input.Keyboard.Key;
  private setter: SceneSetters;

  constructor(setter: SceneSetters) {
    super(sceneConfig);
    this.cursorKeys = undefined;
    this.setter = setter;
  }
  public preload() {}

  public create() {
    this.cursorKeys = this.input.keyboard.addKey("Space");
  }
  public update() {
    //handle up/down cursor keys
    if (this.cursorKeys?.isDown) document.location.reload();
  }
}
